export interface IHistoryItem {
    t: number; // time
    o: number; // open
    c: number; // close
    h: number; // high
    l: number; // low
    v: number;
}

export interface IPeriodsUpdate {
    Symbol: string;
    PeriodType: number;
    Period: IHistoryItem;
}

export interface IHistoryResponse {
    HId: string;
    PipValue: number;
    MaxTime: number;
    MinTime: number;
    HistoryItems: IHistoryItem[];
}

export interface IMomentumParams {
    periodMin: number;
    periodMax: number;
    loadMax: number;
    loadMin: number;
}

export enum HistoryItemPeriod {
    Unknown = -1,
    Min1 = 0,
    Min2 = 23,
    Min3 = 1,
    Min5 = 2,
    Min10 = 3,
    Min15 = 4,
    Min30 = 5,
    Hr1 = 6,
    Hr2 = 24,
    Min90 = 7,
    Min120 = 8,
    Hr3 = 9,
    Hr4 = 10,
    Hr6 = 11,
    Hr24 = 12,
    Week1 = 13,
    Mth1 = 14,
    // Additional from OANDA
    S5 = 15,
    S10 = 16,
    S15 = 17,
    S30 = 18,
    m2 = 19,
    m4 = 20,
    H8 = 21,
    H12 = 22
}

export const PERIOD_TIMESTAMP_MULTIPLIER = 1000;

/*
export function historyPeriods():object {
    let periods: { id: string, label: string, css:string }[] = [
        { "id": HistoryItemPeriod.Min1, "label": "1 minute", "css": "ico-m1" },
        { "id": HistoryItemPeriod.Min3, "label": "3 minutes", "css": "ico-m3" },
        { "id": HistoryItemPeriod.Min5, "label": "5 minutes", "css": "ico-m5" },
        { "id": HistoryItemPeriod.Min10, "label": "10 minutes", "css": "ico-m10" },
        { "id": HistoryItemPeriod.Min15, "label": "15 minutes", "css": "ico-m15" },
        { "id": HistoryItemPeriod.Min30, "label": "30 minutes", "css": "ico-m30" },
        { "id": HistoryItemPeriod.Min90, "label": "90 minutes", "css": "ico-m90" },
        { "id": HistoryItemPeriod.Hr1, "label": "1 hour", "css": "ico-h1" },
        { "id": HistoryItemPeriod.Min120, "label": "2 hours", "css": "ico-h2" },
        { "id": HistoryItemPeriod.Hr3, "label": "3 hours", "css": "ico-h3" },
        { "id": HistoryItemPeriod.Hr4, "label": "4 hours", "css": "ico-h4" }, 
        { "id": HistoryItemPeriod.Hr6, "label": "6 hours", "css": "ico-h6" },
        { "id": HistoryItemPeriod.Hr24, "label": "Daily", "css": "ico-h24" },
        { "id": HistoryItemPeriod.Week1, "label": "1 week", "css": "ico-w1" },
        { "id": HistoryItemPeriod.Mth1, "label": "1 month", "css": "ico-mt1" },
    ];
    return periods;
}
*/

export function getPeriodName(period: number): string {
    var p = historyPeriods().filter(x => x.id == period);
    return p.length > 0 ? p[0].label : "";
}

export function getPeriodCss(period: number): string {
    var p = historyPeriods().filter(x => x.id == period);
    return p.length > 0 ? p[0].css : "";
}

export function historyPeriods(): {
    id: number;
    label: string;
    css: string;
    Order: number;
    Standard?: boolean;
    Oanda?: boolean;
}[] {
    // ORDER !!!!!!!!!
    // Order must by set and incremented with 1000 value step
    let periods: { id: number; label: string; css: string; Order: number; Standard?: boolean; Oanda?: boolean }[] = [
        { id: HistoryItemPeriod.Min1, label: "1M", css: "ico-m1", Order: 14000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Min3, label: "3M", css: "ico-m3", Order: 16000, Standard: true, Oanda: false },
        { id: HistoryItemPeriod.Min5, label: "5M", css: "ico-m5", Order: 18000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Min10, label: "10M", css: "ico-m10", Order: 19000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Min15, label: "15M", css: "ico-m15", Order: 20000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Min30, label: "30M", css: "ico-m30", Order: 21000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Min90, label: "90M", css: "ico-m90", Order: 22000, Standard: true, Oanda: false },
        { id: HistoryItemPeriod.Hr1, label: "1H", css: "ico-h1", Order: 23000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Min120, label: "2H", css: "ico-h2", Order: 24000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Hr2, label: "2H", css: "ico-h2", Order: 24000, Standard: false, Oanda: false },
        { id: HistoryItemPeriod.Hr3, label: "3H", css: "ico-h3", Order: 25000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Hr4, label: "4H", css: "ico-h4", Order: 26000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Hr6, label: "6H", css: "ico-h6", Order: 27000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Hr24, label: "Day", css: "ico-h24", Order: 30000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Week1, label: "WEEK", css: "ico-w1", Order: 31000, Standard: true, Oanda: true },
        { id: HistoryItemPeriod.Mth1, label: "MONTH", css: "ico-mt1", Order: 32000, Standard: true, Oanda: true },

        // Additional from OANDA
        { id: HistoryItemPeriod.S5, label: "5sec", css: "ico-sec5", Order: 10000, Standard: false, Oanda: true },
        { id: HistoryItemPeriod.S10, label: "10sec", css: "ico-sec10", Order: 11000, Standard: false, Oanda: true },
        { id: HistoryItemPeriod.S15, label: "15sec", css: "ico-sec15", Order: 12000, Standard: false, Oanda: true },
        { id: HistoryItemPeriod.S30, label: "30sec", css: "ico-sec30", Order: 13000, Standard: false, Oanda: true },
        { id: HistoryItemPeriod.m2, label: "2M", css: "ico-m2", Order: 15000, Standard: false, Oanda: true },
        { id: HistoryItemPeriod.Min2, label: "2M", css: "ico-m2", Order: 15000, Standard: false, Oanda: false },
        { id: HistoryItemPeriod.m4, label: "4M", css: "ico-m4", Order: 17000, Standard: false, Oanda: true },
        { id: HistoryItemPeriod.H8, label: "8H", css: "ico-h8", Order: 28000, Standard: false, Oanda: true },
        { id: HistoryItemPeriod.H12, label: "12H", css: "ico-h12", Order: 29000, Standard: false, Oanda: true }
    ];

    return periods.sort((a, b) => {
        return a.Order + a.id > b.Order + b.id ? 1 : a.Order + a.id == b.Order + b.id ? 0 : -1;
    });
}

export interface IHistoryItemPeriodTime {
    Period: HistoryItemPeriod;
    Time: number;
}

const sec: number = 1000;
const min: number = sec * 60;
const hour: number = min * 60;
const day: number = hour * 24;
const week: number = 7 * day;
const year: number = day * 365;

export const HistoryItemPeriodValue: IHistoryItemPeriodTime[] = [
    {
        Period: HistoryItemPeriod.S5,
        Time: 5 * sec
    },
    {
        Period: HistoryItemPeriod.S10,
        Time: 10 * sec
    },
    {
        Period: HistoryItemPeriod.S15,
        Time: 15 * sec
    },
    {
        Period: HistoryItemPeriod.S30,
        Time: 30 * sec
    },
    {
        Period: HistoryItemPeriod.Min1,
        Time: min
    },
    {
        Period: HistoryItemPeriod.m2,
        Time: 2 * min
    },
    {
        Period: HistoryItemPeriod.Min3,
        Time: 3 * min
    },
    {
        Period: HistoryItemPeriod.m4,
        Time: 4 * min
    },
    {
        Period: HistoryItemPeriod.Min5,
        Time: 5 * min
    },
    {
        Period: HistoryItemPeriod.Min10,
        Time: 10 * min
    },
    {
        Period: HistoryItemPeriod.Min15,
        Time: 15 * min
    },
    {
        Period: HistoryItemPeriod.Min30,
        Time: 30 * min
    },
    {
        Period: HistoryItemPeriod.Hr1,
        Time: hour
    },
    {
        Period: HistoryItemPeriod.Min90,
        Time: 90 * min
    },
    {
        Period: HistoryItemPeriod.Min120,
        Time: 2 * hour
    },
    {
        Period: HistoryItemPeriod.Hr3,
        Time: 3 * hour
    },
    {
        Period: HistoryItemPeriod.Hr4,
        Time: 4 * hour
    },
    {
        Period: HistoryItemPeriod.Hr6,
        Time: 6 * hour
    },
    {
        Period: HistoryItemPeriod.H8,
        Time: 8 * hour
    },
    {
        Period: HistoryItemPeriod.H12,
        Time: 12 * hour
    },
    {
        Period: HistoryItemPeriod.Hr24,
        Time: day
    },
    {
        Period: HistoryItemPeriod.Week1,
        Time: week
    },
    {
        Period: HistoryItemPeriod.Mth1,
        Time: 30 * day
    }
];

export const HistoryItemPeriodRange: IHistoryItemPeriodTime[] = [
    {
        Period: HistoryItemPeriod.S5,
        Time: 10 * min
    },
    {
        Period: HistoryItemPeriod.S10,
        Time: 15 * min
    },
    {
        Period: HistoryItemPeriod.S30,
        Time: 30 * min
    },
    {
        Period: HistoryItemPeriod.Min1,
        Time: 7 * day
    },
    {
        Period: HistoryItemPeriod.m2,
        Time: 15 * day
    },
    {
        Period: HistoryItemPeriod.Min3,
        Time: 20 * day
    },
    {
        Period: HistoryItemPeriod.Min5,
        Time: 40 * day
    },
    {
        Period: HistoryItemPeriod.Min15,
        Time: 3 * (30 * day)
    },
    {
        Period: HistoryItemPeriod.Min30,
        Time: 6 * (30 * day)
    },
    {
        Period: HistoryItemPeriod.Hr1,
        Time: 1 * year
    },

    {
        Period: HistoryItemPeriod.Min90,
        Time: 1.5 * year
    },
    {
        Period: HistoryItemPeriod.Hr3,
        Time: 3 * year
    },
    {
        Period: HistoryItemPeriod.Hr4,
        Time: 5 * year
    },
    {
        Period: HistoryItemPeriod.Hr6,
        Time: 6 * year
    },
    {
        Period: HistoryItemPeriod.H8,
        Time: 8 * year
    },
    {
        Period: HistoryItemPeriod.H12,
        Time: 12 * year
    },
    {
        Period: HistoryItemPeriod.Hr24,
        Time: 24 * year
    },
    {
        Period: HistoryItemPeriod.Week1,
        Time: 7 * 24 * year
    },
    {
        Period: HistoryItemPeriod.Mth1,
        Time: 50 * year
    }
];

export function getRangeFromHistoryItemPeriod(period: HistoryItemPeriod): number {
    let p: IHistoryItemPeriodTime[] = HistoryItemPeriodRange.filter(x => x.Period === period);
    if (p.length > 0) {
        return p[0].Time;
    }
    return year;
}

export function getHistoryItemPeriodValue(period?: HistoryItemPeriod): number {
    let p: IHistoryItemPeriodTime[] = HistoryItemPeriodValue.filter(x => x.Period === period);
    if (p.length > 0) {
        return p[0].Time;
    }
    return year;
}
